import React, { memo } from 'react'
import { StyledBox } from './styled'

const DotsWrapper = ({ children }: { children: React.ReactNode }) => {
  return <StyledBox>{children}</StyledBox>
}

export default memo(DotsWrapper)
